/**
 * Dealer inventory result pipeline (Dealer Profile M8).
 */
import { parseDealerInventorySearchParams } from "../../constants/dealerInventorySearchParamsConstants";
import { getPublicDealerInventoryListings } from "./dealerInventoryEligibility";
import { applyDealerInventoryFilters, getDealerInventoryAvailableFilters } from "./dealerInventoryFilters";
import { getSortedDealerInventory } from "./dealerInventorySort";

/**
 * @param {import('./dealerProfileTypes').DealerProfile|null|undefined} dealer
 * @param {object[]} rawListings
 * @param {import('../../constants/dealerInventorySearchParamsConstants').DealerInventorySearchParams|object} params
 */
export function getDealerInventoryResult(dealer, rawListings = [], params = {}) {
  const applied = parseDealerInventorySearchParams(params);
  const eligible = getPublicDealerInventoryListings(dealer, rawListings);
  const filtered = applyDealerInventoryFilters(eligible, applied, dealer);
  const sorted = getSortedDealerInventory(filtered, applied.sort);
  const availableFilters = getDealerInventoryAvailableFilters(eligible);

  const filteredCount = sorted.length;
  const pageSize = applied.pageSize;
  const totalPages = Math.max(1, Math.ceil(filteredCount / pageSize));
  const page = Math.min(applied.page, totalPages);
  const visibleCount = Math.min(filteredCount, page * pageSize);

  return {
    listings: sorted.slice(0, visibleCount),
    totalCount: eligible.length,
    filteredCount,
    page,
    pageSize,
    totalPages,
    hasMore: page < totalPages,
    availableFilters,
    appliedFilters: applied,
    sort: applied.sort,
  };
}

/** @deprecated alias */
export function getFilteredDealerInventory(listings, params, dealer) {
  return applyDealerInventoryFilters(listings, params, dealer);
}
